import { Link } from "react-router-dom";

import { PageHeader } from "../../components/ui/PageHeader";
import { t } from "../../lib/i18n";
import { useLocale } from "../../lib/useLocale";

import { RulesListTab } from "./RulesListTab";

export function RulesPage() {
  useLocale();

  return (
    <div>
      <PageHeader
        eyebrow={t("rules.eyebrow")}
        title={t("rules.title")}
        subtitle={t("rules.subtitle")}
        actions={
          <Link to="/network/url-groups" className="btn btn--ghost btn--sm">
            {t("rules.manageDestinations")} →
          </Link>
        }
      />

      <RulesListTab />
    </div>
  );
}
